export const siteSettings = {
  name: "Elite Exchange Pro",
  link: "https://eliteexchangepro.net",
  email: "support@eliteexchangepro.net",
  appLink: "https://app.eliteexchangepro.net",
};
